import React from "react";
import Layout from "../../components/vendor/Layout";
import Helmet from "react-helmet";
import Table from "../../components/ui/Table";
import usePaginate from "../../hooks/api/usePaginate";
import apiRequest from "../../utils/vendor/apiRequest";
import Pagination from "../../components/ui/Pagination";
import { useSelector } from "react-redux";
import { getFileUrl } from "../../utils/helper";

const Orders = () => {
  const {
    currentPage,
    data,
    error,
    fetchData,
    limit,
    loading,
    setPage,
    setSorting,
    sort,
    totalItems,
    totalPages,
  } = usePaginate({
    apiMethod: apiRequest.getVendorOrders, 
    dataKey: "orders",
  });

  const BRAND_NAME = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );

  const handleSort = (field) => {
    const order =
      sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
    setSorting({ sortField: field, sortOrder: order });
  };

  return (
    <Layout>
      <Helmet>
        <title>Vendor Orders - {BRAND_NAME ?? ""}</title>
      </Helmet>

      <div className="p-4 bg-white rounded shadow">
        <h2 className="text-lg font-semibold mb-3">My Orders</h2>

        <Table
          headers={[
            { label: "Order ID", key: "orderId", sorting: false },
            { label: "Customer", key: "userId.name", sorting: false },
            { label: "Items", key: "products", sorting: false },
            { label: "Total Amount", key: "totalAmount", sorting: true },
            { label: "Status", key: "status", sorting: true },
          ]}
          loading={loading}
          handleSort={handleSort}
          sort={sort}
          error={error}
          cols={12}
          renderRow={
            <tbody className="bg-white divide-y divide-gray-200">
              {data?.map((order) => (
                <tr key={order._id} className="hover:bg-gray-50 transition">
                  <td className="px-3 py-3 font-semibold text-gray-800">
                    #{order.orderId}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-700">
                    {order.userId?.name || "Unknown"}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-700">
                    {order.products?.length || 0} items
                  </td>
                  <td className="px-3 py-3 text-sm font-semibold text-green-700">
                    ₹{order.totalAmount?.toFixed(2) || "0.00"}
                  </td>
                  <td className="px-3 py-3">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        order.status === "Completed"
                          ? "bg-green-100 text-green-700"
                          : order.status === "Pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : order.status === "Cancelled"
                          ? "bg-red-100 text-red-700"
                          : "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {order.status}
                    </span>
                  </td>
                
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}
      </div>
    </Layout>
  );
};

export default Orders;
